import { callApi } from '@local_modules/generic/fetch.js'

import htmlTemplate from './show-invite.html'
import { hideElement, setElementHtml, showElement } from '../../../helpers/generic-js/dom.js'
import { acceptInvite } from './accept/accept.js'

/**
 *
 * @returns
 */
export async function showInvite (params) {
  const { inviteId, containerElementId } = params

  document.title = ['Invited to Zenflow'].join(' ')

  setElementHtml(containerElementId, htmlTemplate)

  const inviteData = await loadInvite(inviteId)
  console.log('invite', inviteData)

  showTargetInvite(inviteData)
  addListeners(inviteData)
}

function addListeners (inviteData) {
  console.log('addListeners', inviteData)

  const acceptButton = document.getElementById('acceptInvite')
  acceptButton.addEventListener('click', function (clickEvent) {
    acceptButton.classList.add('is-loading')
    acceptButton.setAttribute('disabled', true)

    // const feedbackElement = document.getElementById('feedback')
    // feedbackElement.innerText = 'Loading'

    acceptInvite(inviteData)
  })
}

async function showTargetInvite (inviteData) {
  hideElement('forAcceptance')
  hideElement('invalidInvite')

  if (inviteData.email) {
    showElement('forAcceptance')

    const accountNameElement = document.getElementById('accountName')
    accountNameElement.innerText = inviteData?.AppAccount?.name
  } else {
    showElement('invalidInvite')
  }
}

async function loadInvite (inviteId) {
  const apiUrl = '/api/user-invites/one/:inviteId'

  const data = await callApi(apiUrl, {
    inviteId
  })

  return data
}
